// extracted by mini-css-extract-plugin
export default {"container":"address_container__262uK","name":"address_name__2ZIEw"};